import "bootstrap";
import React from "react";
import store from "store";
import Authorize from "services/Authorize";
import Routes from "routes/Routes";
import { render } from "react-dom";
import { Provider } from "react-redux";

app.subscribe = store.subscribe;
app.dispatch = store.dispatch;
Object.defineProperty(app, "can", {
  get: () => new Authorize(store).can,
});
Object.defineProperty(app, "ability", {
  get: () => new Authorize(store).ability,
});
Object.defineProperty(app, "haveMenu", {
  get: () => new Authorize(store).haveMenu,
});
Object.defineProperty(app, "haveUiPermission", {
  get: () => new Authorize(store).haveUiPermission,
});
Object.defineProperty(app, "state", {
  get: () => store.getState(),
});
Object.defineProperty(app, "isAdmin", {
  get: () => new Authorize(store).isAdmin,
});

render(
  <Provider store={store}>
    <Routes />
  </Provider>,
  document.getElementById("root")
);
